// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".password-settings-container[data-v-79d180ea]{display:block;width:100%;clear:both;min-height:1rem;padding-top:.8rem;padding-bottom:.4rem}.text-right[data-v-79d180ea]{text-align:right;padding-top:5%;padding-right:16%}[data-v-79d180ea] .form-row .form-row-inner-container{grid-template-columns:none!important}[data-v-79d180ea] .form-row .inputs-container{margin-top:.05rem;padding-left:.35rem;margin-bottom:.1rem;padding-right:.8rem}", ""]);
// Exports
module.exports = exports;
